import { Component, SimpleChanges, Input, OnChanges } from '@angular/core';

import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'fdx-loader',
  template: `
    <ngx-spinner [name]="name">
      <p *ngIf="hasLoadingText" [style.color]="'white'">Loading...</p>
    </ngx-spinner>
  `
})
export class LoaderComponent implements OnChanges {
  @Input() isLoading = false;
  @Input() name = 'primary';
  @Input() hasLoadingText: boolean = true;

  constructor(private spinner: NgxSpinnerService) {}

  ngOnChanges(changes: SimpleChanges): void {
    changes && changes.isLoading.currentValue
      ? this.spinner.show(this.name)
      : this.spinner.hide(this.name);
  }
}
